import React, { Component } from 'react';
import autobind from 'react-autobind';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import IclusigLogo from '../IclusigLogo';

const ActiveArrow = () => {
  return (
    <img className="selector" src="/images/red_circle_arrow_icon.svg" alt="Product selection arrow" />
  );
};

class TreatmentSelector extends Component {
  constructor (props) {
    super(props);
    this.state = {
      primaryState: !props.match.params.environment,
      environmentSelected: '',
    };
    autobind(this);
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (nextProps.match.params.environment !== prevState.environmentSelected) {
      return {
        ...prevState,
        environmentSelected: nextProps.match.params.environment,
      };
    }
    return prevState;
  }

  selectEnvironment () {
    this.setState({
      primaryState: false,
    });
    this.props.setOption('');
  }

  render () {
    const { environmentSelected } = this.state;
    return (
      <div className="treatments">
        <div className="treatment-selector full-width">
          <div className="wrapper">
            <p>To get started, please select your treatment below:</p>
          </div>
        </div>
        <ul className={ `logos ${this.state.primaryState ? 'primary-state' : ''}` }>
          <li
            className={ environmentSelected === 'alunbrig' ? 'alunbrig selected' : 'alunbrig' }
            onClick={ this.selectEnvironment }
          >
            <ActiveArrow />
            <Link to="/alunbrig" className="track track-4 gtm-track-01 track-env-home">
              <img src="/images/ALUNBRIG_logo.svg" alt="ALUNBRIG logo" />
            </Link>
          </li>
          <li
            className={ environmentSelected === 'fruzaqla' ? 'fruzaqla selected' : 'fruzaqla' }
            onClick={ this.selectEnvironment }
          >
            <ActiveArrow />
            <Link to="/fruzaqla" className="track track-82 gtm-track-128 track-env-home">
              <img src="/images/FRUZAQLA_logo.svg" alt="FRUZAQLA logo" />
            </Link>
          </li>
          <li
            className={ environmentSelected === 'iclusig' ? 'iclusig selected' : 'iclusig' }
            onClick={ this.selectEnvironment }
          >
            <ActiveArrow />
            <IclusigLogo
              isLink
              linkTo="/iclusig"
              classTracking="track track-5 gtm-track-02 track-env-home"
              imgLink = "iclusig"
            />
          </li>
          <li
            className={ environmentSelected === 'mimrylo' ? 'mimrylo selected' : 'mimrylo' }
            onClick={ this.selectEnvironment }
          >
            <ActiveArrow />
            <Link to="/mimrylo" className="track track-6 gtm-track-03 track-env-home">
              <img src="/images/MIMRYLO_logo.svg" alt="MIMRYLO logo" />
            </Link>
          </li>
          <li
            className={ environmentSelected === 'ninlaro' ? 'ninlaro selected' : 'ninlaro' }
            onClick={ this.selectEnvironment }
          >
            <ActiveArrow />
            <Link to="/ninlaro" className="track track-6 gtm-track-03 track-env-home">
              <img src="/images/NINLARO_logo.svg" alt="NINLARO logo" />
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

TreatmentSelector.propTypes = {
  setOption: PropTypes.func.isRequired,
};

export default withRouter(TreatmentSelector);
